module.exports = __webpack_public_path__ + "img/AI工厂图.f7096633.png";